"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const initProductDetail = ($productDetail) => {
    var _a;
    const $bottomButton = $productDetail.querySelector('.product-detail__bottom-button');
    const $title = $productDetail.querySelector('.product-detail__title');
    const $badges = $productDetail.querySelector('.product-detail__badges');
    const productId = $productDetail.getAttribute('data-product-id') || 'N/A';
    const initSelectedVariants = () => {
        const variantRadios = $productDetail.querySelectorAll('.variant-radio');
        const $hiddenInput = document.getElementById('selected-variants');
        const updateSelectedVariants = () => {
            var _a, _b;
            const selectedVariants = {};
            // Собираем выбранные варианты
            variantRadios.forEach(($radio) => {
                if ($radio.checked) {
                    selectedVariants[$radio.name] = $radio.value;
                }
            });
            $hiddenInput.value = JSON.stringify(selectedVariants);
            let variantsText = '';
            if (Object.keys(selectedVariants).length > 0) {
                variantsText = 'Выбранные параметры:\n';
                if (selectedVariants['size']) {
                    const sizeText = ((_b = (_a = $productDetail
                        .querySelector(`input[name="size"][value="${selectedVariants['size']}"]`)) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.textContent.trim()) || selectedVariants['size'];
                    variantsText += `  - Размер: ${sizeText}\n`;
                }
                if (selectedVariants['cloth']) {
                    variantsText += `  - Полотно: ${selectedVariants['cloth']}\n`;
                }
            }
            const jsonBottomButton = JSON.parse($bottomButton.getAttribute('data-for-element'));
            jsonBottomButton.text =
                `id продукта: ${productId}\n` +
                    `id выбранного варианта: ${$productDetail.querySelector('.product-detail__offer .product-detail__offer-button--active').getAttribute('data-offer-id')}\n` +
                    `Название продукта: ${$title.textContent.trim()}\n` +
                    variantsText;
            $bottomButton.setAttribute('data-for-element', JSON.stringify(jsonBottomButton));
        };
        if (variantRadios.length > 0 && $hiddenInput) {
            variantRadios.forEach(($radio) => {
                $radio.addEventListener('change', function () {
                    updateSelectedVariants();
                });
            });
            updateSelectedVariants();
        }
    };
    initSelectedVariants();
    try {
        const variantsData = JSON.parse((_a = $productDetail.querySelector('[data-variants-data]')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-variants-data'));
        if (variantsData) {
            let currentOfferId = variantsData[0].id;
            const offerButtons = $productDetail.getElementsByClassName('product-detail__offer-button');
            const OFFER_BUTTON_ACTIVE_CLASSNAME = 'product-detail__offer-button--active';
            const badges = {
                $wrapper: $productDetail.querySelector('.product-detail__badges'),
                $el: $productDetail.querySelector('.product-detail__badge'),
                $elText: $productDetail.querySelector('.product-detail__badge .badge__text'),
                $elArrow: $productDetail.querySelector('.product-detail__badge svg'),
            };
            const changeOffer = (id) => {
                if (currentOfferId === id)
                    return;
                currentOfferId = id;
                const currentVariantData = variantsData.find(variant => variant.id === currentOfferId);
                const updateLayout = () => {
                    const updateButtons = () => {
                        const setActiveState = ($button) => {
                            $button.classList.add(OFFER_BUTTON_ACTIVE_CLASSNAME);
                            $button.setAttribute('tabindex', '-1');
                        };
                        const unsetActiveState = ($button) => {
                            $button.classList.remove(OFFER_BUTTON_ACTIVE_CLASSNAME);
                            $button.removeAttribute('tabindex');
                        };
                        for (const $button of offerButtons) {
                            if ($button.dataset.offerId !== currentOfferId)
                                unsetActiveState($button);
                            else
                                setActiveState($button);
                        }
                    };
                    const updatePageData = () => {
                        document.title = currentVariantData.pageTitle;
                        document
                            .querySelector('meta[name="description"]')
                            .setAttribute('content', currentVariantData.pageDescription);
                        window.history.replaceState({ route: currentVariantData.href }, currentVariantData.pageTitle, currentVariantData.href);
                    };
                    const updateBadges = () => {
                        if (badges.$wrapper) {
                            badges.$wrapper.textContent = '';
                        }
                        if (currentVariantData.badges && currentVariantData.badges.length) {
                            currentVariantData.badges.forEach(badgeData => {
                                badges.$elText.textContent = badgeData.text;
                                badges.$el.style.cssText = `--bg: ${badgeData.bg}; --color: ${badgeData.color};`;
                                if (badgeData.arrow) {
                                    badges.$elArrow.classList.remove('hide');
                                }
                                else {
                                    badges.$elArrow.classList.add('hide');
                                }
                                if (badgeData.link) {
                                    badges.$el.href = badgeData.link;
                                }
                                else {
                                    badges.$el.removeAttribute('href');
                                }
                                const $newBadge = badges.$el.cloneNode(true);
                                badges.$wrapper.appendChild($newBadge);
                            });
                            badges.$wrapper.classList.add('product-detail__badges--visible');
                        }
                        else {
                            if (badges.$wrapper) {
                                badges.$wrapper.classList.remove('product-detail__badges--visible');
                            }
                        }
                    };
                    const updateImages = () => {
                        const swiperElement = document.querySelector('.product-detail__image-wrapper .swiper');
                        if (!swiperElement || !(currentVariantData === null || currentVariantData === void 0 ? void 0 : currentVariantData.images))
                            return;
                        const swiper = swiperElement.swiper;
                        if (!swiper)
                            return;
                        // Обновляем data-count-slides
                        swiperElement.setAttribute('data-count-slides', currentVariantData.images.length);
                        // Обновляем data-looped на родительском элементе
                        const sliderWrapper = swiperElement.closest('.slider-wrapper--primary');
                        if (sliderWrapper) {
                            if (currentVariantData.images.length > 1) {
                                sliderWrapper.setAttribute('data-looped', '');
                                swiper.params.loop = 'true';
                            }
                            else {
                                sliderWrapper.removeAttribute('data-looped');
                                swiper.params.loop = 'false';
                            }
                        }
                        // Создаем новые слайды
                        const slides = currentVariantData.detail_image
                            .map(item => `
							<div class="swiper-slide">
								<a data-pswp-src>
									<img src="${item.url}" alt="${item.alt || ''}">
								</a>
							</div>
						`)
                            .join('');
                        // Обновляем swiper-wrapper напрямую
                        const $wrapper = swiperElement.querySelector('.swiper-wrapper');
                        if ($wrapper) {
                            $wrapper.innerHTML = slides;
                        }
                        // Обновляем Swiper
                        swiper.update();
                        swiper.slideTo(0);
                    };
                    const updateContent = () => {
                        var _a, _b, _c;
                        const $content = $productDetail.querySelector('.product-detail__content');
                        if (!$content)
                            return;
                        // Обновление простых элементов с data-prop-bind-name
                        $content.querySelectorAll('[data-prop-bind-name]').forEach($el => {
                            const propName = $el.getAttribute('data-prop-bind-name');
                            if (!propName)
                                return;
                            let newValue = propName.includes('.')
                                ? propName.split('.').reduce((obj, key) => obj === null || obj === void 0 ? void 0 : obj[key], currentVariantData)
                                : currentVariantData[propName];
                            if (newValue === undefined)
                                return;
                            if (propName.toLowerCase().includes('price')) {
                                newValue = newValue; // Возвращаем форматирование цен
                            }
                            const changeType = $el.getAttribute('data-prop-change-type');
                            if (changeType === 'attr') {
                                const attrName = $el.getAttribute('data-prop-change-attr-name');
                                if (attrName)
                                    $el.setAttribute(attrName, newValue);
                            }
                            else {
                                $el.textContent = newValue;
                            }
                        });
                        // Обновление списка examples
                        const $examplesWrapper = $content.querySelector('.product-detail__examples .swiper-wrapper');
                        if ($examplesWrapper && currentVariantData.examples) {
                            $examplesWrapper.innerHTML = currentVariantData.examples
                                .map(item => `
										<div class="swiper-slide">
											<a data-pswp-src class="bg-default-dark">
												<img src="${item.url}" alt="${item.alternativeText || ''}">
											</a>
										</div>
									`)
                                .join('');
                            const $swiper = $examplesWrapper.closest('.swiper');
                            if ($swiper) {
                                $swiper.setAttribute('data-count-slides', currentVariantData.examples.length);
                            }
                        }
                        const $complectPrice = $content.querySelector('.accordion__header .product-detail__prices-item .product-detail__prices-value');
                        const $oldComplectPrice = $content.querySelector('.accordion__header .product-detail__prices-item .product-detail__prices-value--old');
                        if ($complectPrice && ((_a = currentVariantData.complect) === null || _a === void 0 ? void 0 : _a.price)) {
                            $complectPrice.textContent = currentVariantData.complect.price;
                        }
                        if ($oldComplectPrice && ((_b = currentVariantData.complect) === null || _b === void 0 ? void 0 : _b.old_complect_price)) {
                            $oldComplectPrice.textContent = currentVariantData.complect.old_complect_price;
                        }
                        // Обновление списка complect.items
                        const $complectList = $content.querySelector('.product-detail__prices-complect-list');
                        if ($complectList && ((_c = currentVariantData.complect) === null || _c === void 0 ? void 0 : _c.items)) {
                            $complectList.innerHTML = currentVariantData.complect.items
                                .map(item => `
										<li class="product-detail__prices-complect-list-item">
											<div class="product-detail__prices-complect-list-item-main">
												<span class="product-detail__prices-complect-list-item-title">${item.name}</span>
												<span class="product-detail__prices-complect-list-item-count">${item.count}</span>
											</div>
											<span class="product-detail__prices-complect-list-item-value">${item.price}</span>
										</li>
									`)
                                .join('');
                        }
                        // Обновление блока info
                        const $infoBody = $content.querySelector('.product-detail__info .product-detail__block-body');
                        if ($infoBody && currentVariantData.info) {
                            $infoBody.innerHTML = currentVariantData.info
                                .map(infoItem => `
										<bm-accordion modification="primary">
											<div class="accordion__header">
												<button class="accordion__header-button" type="button">
													<span class="accordion__header-title">${infoItem.name}</span>
													<span class="accordion__header-icon">
														<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M8.00099 11.2004C7.53432 11.2004 7.06766 11.0204 6.71432 10.6671L2.36766 6.32042C2.17432 6.12708 2.17432 5.80708 2.36766 5.61375C2.56099 5.42042 2.88099 5.42042 3.07432 5.61375L7.42099 9.96042C7.74099 10.2804 8.26099 10.2804 8.58099 9.96042L12.9277 5.61375C13.121 5.42042 13.441 5.42042 13.6343 5.61375C13.8277 5.80708 13.8277 6.12708 13.6343 6.32042L9.28766 10.6671C8.93432 11.0204 8.46766 11.2004 8.00099 11.2004Z" fill="#878787" />
														</svg>
													</span>
												</button>
											</div>
											<div class="accordion__body">
												<div class="accordion__body-container">
													<div class="accordion__content">
														${infoItem.contentType === 'rte'
                                ? `<div class="rte--light rte">${infoItem.content}</div>`
                                : infoItem.contentType === 'list'
                                    ? `
																		<div class="product-detail__characteristics">
																			${infoItem.items
                                        .map(item => `
																						<div class="product-detail__characteristics-item">
																							<span class="product-detail__characteristics-item-name">${item.name}</span>
																							<span class="product-detail__characteristics-item-value">${item.value}</span>
																						</div>
																					`)
                                        .join('')}
																		</div>
																	`
                                    : ''}
													</div>
												</div>
											</div>
										</bm-accordion>
									`)
                                .join('');
                        }
                        // Обновление кнопки "Заказать"
                        const $orderButton = $content.querySelector('.product-detail__bottom-button');
                        if ($orderButton && currentVariantData.name) {
                            $orderButton.setAttribute('data-for-element', `{"selector": "#callbackModal .form-additional-info", "text": "Товар: \\"${currentVariantData.name}\\".", "how": "value"}`);
                        }
                        // Обновление блока variants
                        const $variantsContainer = $content.querySelector('.product-detail__content');
                        if (currentVariantData.variants) {
                            const $existingVariants = $content.querySelectorAll('.product-detail__variant');
                            $existingVariants.forEach($el => $el.remove()); // Удаляем старые варианты
                            const variantsHtml = currentVariantData.variants
                                .map(variantsItem => `
										<div class="product-detail__variant product-detail__block" data-name="${variantsItem.name}">
											<div class="product-detail__block-header">
												<span class="product-detail__block-title">${variantsItem.title}</span>
											</div>
											<div class="product-detail__block-body">
												${variantsItem.type === 'text'
                                ? variantsItem.items
                                    .map((item, index) => `
																	<label class="variant-option variant-option--text">
																		<input type="radio"
																			name="${variantsItem.name}"
																			value="${item.value}"
																			class="variant-radio"
																			${index === 0 ? 'checked' : ''}
																		>
																		<span>${item.text}</span>
																	</label>
																`)
                                    .join('')
                                : variantsItem.type === 'image'
                                    ? variantsItem.items
                                        .map((item, index) => `
																		<label class="variant-option variant-option--image">
																			<input type="radio"
																				name="${variantsItem.name}"
																				value="${item.value}"
																				class="variant-radio"
																				${index === 0 ? 'checked' : ''}
																			>
																			<img src="${item.url}" alt="">
																		</label>
																	`)
                                        .join('')
                                    : ''}
											</div>
										</div>
									`)
                                .join('');
                            // Вставляем новые варианты перед скрытым input или в конец контента
                            const $hiddenInput = $content.querySelector('#selected-variants');
                            if ($hiddenInput) {
                                $hiddenInput.insertAdjacentHTML('beforebegin', variantsHtml);
                            }
                            else {
                                $content.insertAdjacentHTML('beforeend', variantsHtml);
                            }
                            initSelectedVariants();
                        }
                    };
                    const updateBreadcrumbs = () => {
                        document.querySelectorAll('.breadcrumb .breadcrumb__item:last-child').forEach($item => {
                            $item.textContent = currentVariantData.name;
                        });
                    };
                    const reinitPhotoswipe = () => {
                        $productDetail.querySelectorAll('[data-pswp-papik]').forEach(($papik) => {
                            window.photoSwipeFunctions.updateAllSrcData($papik);
                            window.photoSwipeFunctions.initPapik($papik);
                        });
                    };
                    updatePageData();
                    updateButtons();
                    updateBadges();
                    updateImages();
                    updateContent();
                    updateBreadcrumbs();
                    setTimeout(() => {
                        reinitPhotoswipe();
                    }, 500);
                };
                updateLayout();
            };
            for (const $button of offerButtons) {
                $button.addEventListener('click', () => {
                    changeOffer($button.getAttribute('data-offer-id'));
                });
            }
        }
    }
    catch (error) {
        console.warn(error);
    }
};
exports.default = initProductDetail;
